import { render, staticRenderFns } from "./ButtonReturn.vue?vue&type=template&id=05615e14&scoped=true&"
import script from "./ButtonReturn.vue?vue&type=script&lang=ts&"
export * from "./ButtonReturn.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonReturn.vue?vue&type=style&index=0&id=05615e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05615e14",
  null
  
)

export default component.exports